import type { Product } from '@techpos/contracts';
import { MAX_SAFE_FINANCIAL_UNITS, splitInclusiveTax } from '@techpos/domain';

/** Normal catalogue price, before location overrides or customer discounts. */
export function productMargin(product: Pick<Product, 'priceMode' | 'normalSellingPriceIncGstPence' | 'standardCostExGstUnits' | 'taxRatePpm'>): string {
  const { normalSellingPriceIncGstPence: gross, standardCostExGstUnits: cost, taxRatePpm: tax } = product;
  if (product.priceMode !== 'FIXED' || gross == null || !Number.isSafeInteger(gross) || gross <= 0 || gross > Number(MAX_SAFE_FINANCIAL_UNITS)
    || cost == null || !Number.isSafeInteger(cost) || cost < 0
    || !Number.isSafeInteger(tax) || tax < 0 || tax > 1_000_000) return '—';
  const { netPence } = splitInclusiveTax(gross, tax);
  if (netPence <= 0) return '—';
  // Cost has four decimal places; retain that precision until percentage display.
  const margin = (netPence - cost / 100) / netPence * 100;
  return `${(Math.abs(margin) < 0.05 ? 0 : margin).toFixed(1)}%`;
}
